module.exports = __webpack_public_path__ + "img/ltrs-icon.b5baf099.png";